export const COUNTRIES = [
    {code: 'AF', gname: 'AFGHANISTAN', name: 'Afghanistan'},
    {code: 'AX', gname: '&#197;LAND ISLANDS', name: 'Åland Islands'},
    {code: 'AL', gname: 'ALBANIA', name: 'Albania'},
    {code: 'DZ', gname: 'ALGERIA', name: 'Algeria'},
    {code: 'AS', gname: 'AMERICAN SAMOA', name: 'American Samoa'},
    {code: 'AD', gname: 'ANDORRA', name: 'Andorra'},
    {code: 'AO', gname: 'ANGOLA', name: 'Angola'},
    {code: 'AI', gname: 'ANGUILLA', name: 'Anguilla'},
    {code: 'AQ', gname: 'ANTARCTICA', name: 'Antarctica'},
    {code: 'AG', gname: 'ANTIGUA AND BARBUDA', name: 'Antigua and Barbuda'},
    {code: 'AR', gname: 'ARGENTINA', name: 'Argentina'},
    {code: 'AM', gname: 'ARMENIA', name: 'Armenia'},
    {code: 'AW', gname: 'ARUBA', name: 'Aruba'},
    {code: 'AU', gname: 'AUSTRALIA', name: 'Australia'},
    {code: 'AT', gname: 'AUSTRIA', name: 'Austria'},
    {code: 'AZ', gname: 'AZERBAIJAN', name: 'Azerbaijan'},
    {code: 'BS', gname: 'BAHAMAS', name: 'Bahamas'},
    {code: 'BH', gname: 'BAHRAIN', name: 'Bahrain'},
    {code: 'BD', gname: 'BANGLADESH', name: 'Bangladesh'},
    {code: 'BB', gname: 'BARBADOS', name: 'Barbados'},
    {code: 'BY', gname: 'BELARUS', name: 'Belarus'},
    {code: 'BE', gname: 'BELGIUM', name: 'Belgium'},
    {code: 'BZ', gname: 'BELIZE', name: 'Belize'},
    {code: 'BJ', gname: 'BENIN', name: 'Benin'},
    {code: 'BM', gname: 'BERMUDA', name: 'Bermuda'},
    {code: 'BT', gname: 'BHUTAN', name: 'Bhutan'},
    {code: 'BO', gname: 'BOLIVIA', name: 'Bolivia'},
    {code: 'BA', gname: 'BOSNIA AND HERZEGOVINA', name: 'Bosnia and Herzegovina'},
    {code: 'BW', gname: 'BOTSWANA', name: 'Botswana'},
    {code: 'BV', gname: 'BOUVET ISLAND', name: 'Bouvet Island'},
    {code: 'BR', gname: 'BRAZIL', name: 'Brazil'},
    {code: 'IO', gname: 'BRITISH INDIAN OCEAN TERRITORY', name: 'British Indian Ocean Territory'},
    {code: 'BN', gname: 'BRUNEI DARUSSALAM', name: 'Brunei Darussalam'},
    {code: 'BG', gname: 'BULGARIA', name: 'Bulgaria'},
    {code: 'BF', gname: 'BURKINA FASO', name: 'Burkina Faso'},
    {code: 'BI', gname: 'BURUNDI', name: 'Burundi'},
    {code: 'KH', gname: 'CAMBODIA', name: 'Cambodia'},
    {code: 'CM', gname: 'CAMEROON', name: 'Cameroon'},
    {code: 'CA', gname: 'CANADA', name: 'Canada'},
    {code: 'CV', gname: 'CAPE VERDE', name: 'Cape Verde'},
    {code: 'KY', gname: 'CAYMAN ISLANDS', name: 'Cayman Islands'},
    {code: 'CF', gname: 'CENTRAL AFRICAN REPUBLIC', name: 'Central African Republic'},
    {code: 'TD', gname: 'CHAD', name: 'Chad'},
    {code: 'CL', gname: 'CHILE', name: 'Chile'},
    {code: 'CN', gname: 'CHINA', name: 'China'},
    {code: 'CX', gname: 'CHRISTMAS ISLAND', name: 'Christmas Island'},
    {code: 'CC', gname: 'COCOS (KEELING) ISLANDS', name: 'Cocos (Keeling) Islands'},
    {code: 'CO', gname: 'COLOMBIA', name: 'Colombia'},
    {code: 'KM', gname: 'COMOROS', name: 'Comoros'},
    {code: 'CG', gname: 'CONGO', name: 'Congo'},
    {code: 'CD', gname: 'CONGO, THE DEMOCRATIC REPUBLIC OF THE', name: 'Congo, The Democratic Republic of the'},
    {code: 'CK', gname: 'COOK ISLANDS', name: 'Cook Islands'},
    {code: 'CR', gname: 'COSTA RICA', name: 'Costa Rica'},
    {code: 'CI', gname: 'C&#212;TE D&#39;IVOIRE', name: 'Côte d\'Ivoire'},
    {code: 'HR', gname: 'CROATIA', name: 'Croatia'},
    {code: 'CU', gname: 'CUBA', name: 'Cuba'},
    {code: 'CY', gname: 'CYPRUS', name: 'Cyprus'},
    {code: 'CZ', gname: 'CZECH REPUBLIC', name: 'Czech Republic'},
    {code: 'DK', gname: 'DENMARK', name: 'Denmark'},
    {code: 'DJ', gname: 'DJIBOUTI', name: 'Djibouti'},
    {code: 'DM', gname: 'DOMINICA', name: 'Dominica'},
    {code: 'DO', gname: 'DOMINICAN REPUBLIC', name: 'Dominican Republic'},
    {code: 'EC', gname: 'ECUADOR', name: 'Ecuador'},
    {code: 'EG', gname: 'EGYPT', name: 'Egypt'},
    {code: 'SV', gname: 'EL SALVADOR', name: 'El Salvador'},
    {code: 'GQ', gname: 'EQUATORIAL GUINEA', name: 'Equatorial Guinea'},
    {code: 'ER', gname: 'ERITREA', name: 'Eritrea'},
    {code: 'EE', gname: 'ESTONIA', name: 'Estonia'},
    {code: 'ET', gname: 'ETHIOPIA', name: 'Ethiopia'},
    {code: 'FK', gname: 'FALKLAND ISLANDS (MALVINAS)', name: 'Falkland Islands (Malvinas)'},
    {code: 'FO', gname: 'FAROE ISLANDS', name: 'Faroe Islands'},
    {code: 'FJ', gname: 'FIJI', name: 'Fiji'},
    {code: 'FI', gname: 'FINLAND', name: 'Finland'},
    {code: 'FR', gname: 'FRANCE', name: 'France'},
    {code: 'GF', gname: 'FRENCH GUIANA', name: 'French Guiana'},
    {code: 'PF', gname: 'FRENCH POLYNESIA', name: 'French Polynesia'},
    {code: 'TF', gname: 'FRENCH SOUTHERN TERRITORIES', name: 'French Southern Territories'},
    {code: 'GA', gname: 'GABON', name: 'Gabon'},
    {code: 'GM', gname: 'GAMBIA', name: 'Gambia'},
    {code: 'GE', gname: 'GEORGIA', name: 'Georgia'},
    {code: 'DE', gname: 'GERMANY', name: 'Germany'},
    {code: 'GH', gname: 'GHANA', name: 'Ghana'},
    {code: 'GI', gname: 'GIBRALTAR', name: 'Gibraltar'},
    {code: 'GR', gname: 'GREECE', name: 'Greece'},
    {code: 'GL', gname: 'GREENLAND', name: 'Greenland'},
    {code: 'GD', gname: 'GRENADA', name: 'Grenada'},
    {code: 'GP', gname: 'GUADELOUPE', name: 'Guadeloupe'},
    {code: 'GU', gname: 'GUAM', name: 'Guam'},
    {code: 'GT', gname: 'GUATEMALA', name: 'Guatemala'},
    {code: 'GG', gname: 'GUERNSEY', name: 'Guernsey'},
    {code: 'GN', gname: 'GUINEA', name: 'Guinea'},
    {code: 'GW', gname: 'GUINEA-BISSAU', name: 'Guinea-Bissau'},
    {code: 'GY', gname: 'GUYANA', name: 'Guyana'},
    {code: 'HT', gname: 'HAITI', name: 'Haiti'},
    {code: 'HM', gname: 'HEARD ISLAND AND MCDONALD ISLANDS', name: 'Heard Island and McDonald Islands'},
    {code: 'VA', gname: 'HOLY SEE (VATICAN CITY STATE)', name: 'Holy See (Vatican City State)'},
    {code: 'HN', gname: 'HONDURAS', name: 'Honduras'},
    {code: 'HK', gname: 'HONG KONG', name: 'Hong Kong'},
    {code: 'HU', gname: 'HUNGARY', name: 'Hungary'},
    {code: 'IS', gname: 'ICELAND', name: 'Iceland'},
    {code: 'IN', gname: 'INDIA', name: 'India'},
    {code: 'ID', gname: 'INDONESIA', name: 'Indonesia'},
    {code: 'IR', gname: 'IRAN, ISLAMIC REPUBLIC OF', name: 'Iran, Islamic Republic of'},
    {code: 'IQ', gname: 'IRAQ', name: 'Iraq'},
    {code: 'IE', gname: 'IRELAND', name: 'Ireland'},
    {code: 'IM', gname: 'ISLE OF MAN', name: 'Isle of Man'},
    {code: 'IL', gname: 'ISRAEL', name: 'Israel'},
    {code: 'IT', gname: 'ITALY', name: 'Italy'},
    {code: 'JM', gname: 'JAMAICA', name: 'Jamaica'},
    {code: 'JP', gname: 'JAPAN', name: 'Japan'},
    {code: 'JE', gname: 'JERSEY', name: 'Jersey'},
    {code: 'JO', gname: 'JORDAN', name: 'Jordan'},
    {code: 'KZ', gname: 'KAZAKHSTAN', name: 'Kazakhstan'},
    {code: 'KE', gname: 'KENYA', name: 'Kenya'},
    {code: 'KI', gname: 'KIRIBATI', name: 'Kiribati'},
    {code: 'KP', gname: 'KOREA, DEMOCRATIC PEOPLE&#39;S REPUBLIC OF', name: 'Korea, Democratic People&#39;s Republic of'},
    {code: 'KR', gname: 'KOREA, REPUBLIC OF', name: 'Korea, Republic of'},
    {code: 'KW', gname: 'KUWAIT', name: 'Kuwait'},
    {code: 'KG', gname: 'KYRGYZSTAN', name: 'Kyrgyzstan'},
    {code: 'LA', gname: 'LAO PEOPLE&#39;S DEMOCRATIC REPUBLIC', name: 'Lao People&#39;s Democratic Republic'},
    {code: 'LV', gname: 'LATVIA', name: 'Latvia'},
    {code: 'LB', gname: 'LEBANON', name: 'Lebanon'},
    {code: 'LS', gname: 'LESOTHO', name: 'Lesotho'},
    {code: 'LR', gname: 'LIBERIA', name: 'Liberia'},
    {code: 'LY', gname: 'LIBYAN ARAB JAMAHIRIYA', name: 'Libyan Arab Jamahiriya'},
    {code: 'LI', gname: 'LIECHTENSTEIN', name: 'Liechtenstein'},
    {code: 'LT', gname: 'LITHUANIA', name: 'Lithuania'},
    {code: 'LU', gname: 'LUXEMBOURG', name: 'Luxembourg'},
    {code: 'MO', gname: 'MACAO', name: 'Macao'},
    {code: 'MK', gname: 'MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF', name: 'Macedonia, The Former Yugoslav Republic of'},
    {code: 'MG', gname: 'MADAGASCAR', name: 'Madagascar'},
    {code: 'MW', gname: 'MALAWI', name: 'Malawi'},
    {code: 'MY', gname: 'MALAYSIA', name: 'Malaysia'},
    {code: 'MV', gname: 'MALDIVES', name: 'Maldives'},
    {code: 'ML', gname: 'MALI', name: 'Mali'},
    {code: 'MT', gname: 'MALTA', name: 'Malta'},
    {code: 'MH', gname: 'MARSHALL ISLANDS', name: 'Marshall Islands'},
    {code: 'MQ', gname: 'MARTINIQUE', name: 'Martinique'},
    {code: 'MR', gname: 'MAURITANIA', name: 'Mauritania'},
    {code: 'MU', gname: 'MAURITIUS', name: 'Mauritius'},
    {code: 'YT', gname: 'MAYOTTE', name: 'Mayotte'},
    {code: 'MX', gname: 'MEXICO', name: 'Mexico'},
    {code: 'FM', gname: 'MICRONESIA, FEDERATED STATES OF', name: 'Micronesia, Federated States of'},
    {code: 'MD', gname: 'MOLDOVA, REPUBLIC OF', name: 'Moldova, Republic of'},
    {code: 'MC', gname: 'MONACO', name: 'Monaco'},
    {code: 'MN', gname: 'MONGOLIA', name: 'Mongolia'},
    {code: 'ME', gname: 'MONTENEGRO', name: 'Montenegro'},
    {code: 'MS', gname: 'MONTSERRAT', name: 'Montserrat'},
    {code: 'MA', gname: 'MOROCCO', name: 'Morocco'},
    {code: 'MZ', gname: 'MOZAMBIQUE', name: 'Mozambique'},
    {code: 'MM', gname: 'MYANMAR', name: 'Myanmar'},
    {code: 'NA', gname: 'NAMIBIA', name: 'Namibia'},
    {code: 'NR', gname: 'NAURU', name: 'Nauru'},
    {code: 'NP', gname: 'NEPAL', name: 'Nepal'},
    {code: 'NL', gname: 'NETHERLANDS', name: 'Netherlands'},
    {code: 'AN', gname: 'NETHERLANDS ANTILLES', name: 'Netherlands Antilles'},
    {code: 'NC', gname: 'NEW CALEDONIA', name: 'New Caledonia'},
    {code: 'NZ', gname: 'NEW ZEALAND', name: 'New Zealand'},
    {code: 'NI', gname: 'NICARAGUA', name: 'Nicaragua'},
    {code: 'NE', gname: 'NIGER', name: 'Niger'},
    {code: 'NG', gname: 'NIGERIA', name: 'Nigeria'},
    {code: 'NU', gname: 'NIUE', name: 'Niue'},
    {code: 'NF', gname: 'NORFOLK ISLAND', name: 'Norfolk Island'},
    {code: 'MP', gname: 'NORTHERN MARIANA ISLANDS', name: 'Northern Mariana Islands'},
    {code: 'NO', gname: 'NORWAY', name: 'Norway'},
    {code: 'OM', gname: 'OMAN', name: 'Oman'},
    {code: 'PK', gname: 'PAKISTAN', name: 'Pakistan'},
    {code: 'PW', gname: 'PALAU', name: 'Palau'},
    {code: 'PS', gname: 'PALESTINIAN TERRITORY, OCCUPIED', name: 'Palestinian Territory, Occupied'},
    {code: 'PA', gname: 'PANAMA', name: 'Panama'},
    {code: 'PG', gname: 'PAPUA NEW GUINEA', name: 'Papua New Guinea'},
    {code: 'PY', gname: 'PARAGUAY', name: 'Paraguay'},
    {code: 'PE', gname: 'PERU', name: 'Peru'},
    {code: 'PH', gname: 'PHILIPPINES', name: 'Philippines'},
    {code: 'PN', gname: 'PITCAIRN', name: 'Pitcairn'},
    {code: 'PL', gname: 'POLAND', name: 'Poland'},
    {code: 'PT', gname: 'PORTUGAL', name: 'Portugal'},
    {code: 'PR', gname: 'PUERTO RICO', name: 'Puerto Rico'},
    {code: 'QA', gname: 'QATAR', name: 'Qatar'},
    {code: 'RE', gname: 'RÉUNION', name: 'Réunion'},
    {code: 'RO', gname: 'ROMANIA', name: 'Romania'},
    {code: 'RU', gname: 'RUSSIAN FEDERATION', name: 'Russian Federation'},
    {code: 'RW', gname: 'RWANDA', name: 'Rwanda'},
    {code: 'SH', gname: 'SAINT HELENA', name: 'Saint Helena'},
    {code: 'KN', gname: 'SAINT KITTS AND NEVIS', name: 'Saint Kitts and Nevis'},
    {code: 'LC', gname: 'SAINT LUCIA', name: 'Saint Lucia'},
    {code: 'PM', gname: 'SAINT PIERRE AND MIQUELON', name: 'Saint Pierre and Miquelon'},
    {code: 'VC', gname: 'SAINT VINCENT AND THE GRENADINES', name: 'Saint Vincent and the Grenadines'},
    {code: 'WS', gname: 'SAMOA', name: 'Samoa'},
    {code: 'SM', gname: 'SAN MARINO', name: 'San Marino'},
    {code: 'ST', gname: 'SAO TOME AND PRINCIPE', name: 'Sao Tome and Principe'},
    {code: 'SA', gname: 'SAUDI ARABIA', name: 'Saudi Arabia'},
    {code: 'SN', gname: 'SENEGAL', name: 'Senegal'},
    {code: 'RS', gname: 'SERBIA', name: 'Serbia'},
    {code: 'SC', gname: 'SEYCHELLES', name: 'Seychelles'},
    {code: 'SL', gname: 'SIERRA LEONE', name: 'Sierra Leone'},
    {code: 'SG', gname: 'SINGAPORE', name: 'Singapore'},
    {code: 'SK', gname: 'SLOVAKIA', name: 'Slovakia'},
    {code: 'SI', gname: 'SLOVENIA', name: 'Slovenia'},
    {code: 'SB', gname: 'SOLOMON ISLANDS', name: 'Solomon Islands'},
    {code: 'SO', gname: 'SOMALIA', name: 'Somalia'},
    {code: 'ZA', gname: 'SOUTH AFRICA', name: 'South Africa'},
    {code: 'GS', gname: 'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS', name: 'South Georgia and the South Sandwich Islands'},
    {code: 'ES', gname: 'SPAIN', name: 'Spain'},
    {code: 'LK', gname: 'SRI LANKA', name: 'Sri Lanka'},
    {code: 'SD', gname: 'SUDAN', name: 'Sudan'},
    {code: 'SR', gname: 'SURINAME', name: 'Suriname'},
    {code: 'SJ', gname: 'SVALBARD AND JAN MAYEN', name: 'Svalbard and Jan Mayen'},
    {code: 'SZ', gname: 'SWAZILAND', name: 'Swaziland'},
    {code: 'SE', gname: 'SWEDEN', name: 'Sweden'},
    {code: 'CH', gname: 'SWITZERLAND', name: 'Switzerland'},
    {code: 'SY', gname: 'SYRIAN ARAB REPUBLIC', name: 'Syrian Arab Republic'},
    {code: 'TW', gname: 'TAIWAN, PROVINCE OF CHINA', name: 'Taiwan, Province of China'},
    {code: 'TJ', gname: 'TAJIKISTAN', name: 'Tajikistan'},
    {code: 'TZ', gname: 'TANZANIA, UNITED REPUBLIC OF', name: 'Tanzania, United Republic of'},
    {code: 'TH', gname: 'THAILAND', name: 'Thailand'},
    {code: 'TL', gname: 'TIMOR-LESTE', name: 'Timor-Leste'},
    {code: 'TG', gname: 'TOGO', name: 'Togo'},
    {code: 'TK', gname: 'TOKELAU', name: 'Tokelau'},
    {code: 'TO', gname: 'TONGA', name: 'Tonga'},
    {code: 'TT', gname: 'TRINIDAD AND TOBAGO', name: 'Trinidad and Tobago'},
    {code: 'TN', gname: 'TUNISIA', name: 'Tunisia'},
    {code: 'TR', gname: 'TURKEY', name: 'Turkey'},
    {code: 'TM', gname: 'TURKMENISTAN', name: 'Turkmenistan'},
    {code: 'TC', gname: 'TURKS AND CAICOS ISLANDS', name: 'Turks and Caicos Islands'},
    {code: 'TV', gname: 'TUVALU', name: 'Tuvalu'},
    {code: 'UG', gname: 'UGANDA', name: 'Uganda'},
    {code: 'UA', gname: 'UKRAINE', name: 'Ukraine'},
    {code: 'AE', gname: 'UNITED ARAB EMIRATES', name: 'United Arab Emirates'},
    {code: 'GB', gname: 'UNITED KINGDOM', name: 'United Kingdom'},
    {code: 'US', gname: 'UNITED STATES', name: 'United States'},
    {code: 'UM', gname: 'UNITED STATES MINOR OUTLYING ISLANDS', name: 'United States Minor Outlying Islands'},
    {code: 'UN', gname: 'Unknown', name: 'Unknown'},
    {code: 'UY', gname: 'URUGUAY', name: 'Uruguay'},
    {code: 'UZ', gname: 'UZBEKISTAN', name: 'Uzbekistan'},
    {code: 'VU', gname: 'VANUATU', name: 'Vanuatu'},
    {code: 'VE', gname: 'VENEZUELA', name: 'Venezuela'},
    {code: 'VN', gname: 'VIET NAM', name: 'Viet Nam'},
    {code: 'VG', gname: 'VIRGIN ISLANDS, BRITISH', name: 'Virgin Islands, British'},
    {code: 'VI', gname: 'VIRGIN ISLANDS, U.S.', name: 'Virgin Islands, U.S.'},
    {code: 'WF', gname: 'WALLIS AND FUTUNA', name: 'Wallis and Futuna'},
    {code: 'EH', gname: 'WESTERN SAHARA', name: 'Western Sahara'},
    {code: 'YE', gname: 'YEMEN', name: 'Yemen'},
    {code: 'ZM', gname: 'ZAMBIA', name: 'Zambia'},
    {code: 'ZW', gname: 'ZIMBABWE', name: 'Zimbabwe'},
];

export function populateCountrySelects(selectIds = []) {
  selectIds.forEach(id => {
    const sel = document.getElementById(id);
    if (!sel) return;
    // get the current selected value
    const selectedValue = sel.value;
    // clear the select options
    sel.innerHTML = `<option value="">Select</option>`;
    COUNTRIES.forEach(c => {
      const o = document.createElement("option");
      o.value = c.code;
      o.textContent = c.name;
      // if the current option is the selected value, set it as selected
      if (c.code === selectedValue) {
        o.selected = true;
      }
      // append the option to the select element
      sel.appendChild(o);
    });
  });
}

// Initialize Select2
export function initCountrySelect2(ids = []) {
  ids.forEach(id => {
    $(`#${id}`)
      .select2({
        theme: 'bootstrap-5',
        placeholder: "Select a country",
        allowClear: false,
      })
  });
}
